import { IntelligentSupplierRecommendations } from "@/components/IntelligentSupplierRecommendations";

export default function SupplierRecommendations() {
  return <IntelligentSupplierRecommendations />;
}